// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
// 引入公共组件editor
import UE from '../../../../components/public/ue.vue';
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  components: { UE },
  data() {
    return {
      title: '', // 面包屑标题
      buttonProps: {
        type: 'ghost',
        size: 'small',
      },
      //= =========================以下是模态框相关
      modal1: false, // 模态框显示开关，true显示   false不显示
      cate_name: '', // 输入的名字
      pid: '', // 选中的父级id
      cateid: '', // 分类id（修改时使用~）
    };
  },
  created() {
    const self = this;
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
  },
  computed: {
    categorylist() {
      return this.$store.state.product.productCategory;
      // console.log(this.$store.state.product.productCategory);
    },
    categoryonelist() {
      return this.$store.state.product.productCategorySelect;
      // console.log(this.$store.state.product.productCategorySelect);
    },
  },
  methods: {
    // 添加文章分类（打开模态框）；
    addArticleCategory() {
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
    },
    // 添加弹出框点击确定之后走的方法
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      if (this.cate_name == '') {
        this.$Message.warning('分类名不能为空');
        return false;
      }
      axios({
        method: 'post',
        url: '/admin/product/productCategoryUpdate',
        data: { cate_name: this.cate_name, pid: this.pid, cateid: this.cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$store.commit('getProductCateAgain');
            self.cate_name = '';
            self.pid = '';
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
          } else {
            self.cate_name = '';
            self.pid = '';
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
    // 添加弹出框点击取消走的方法
    cancel() {
      this.modal1 = false;
    },
    // 点击每个一级分类前面的小图标执行的事件
    letgo(getid) {
      this.$store.commit('changeCatePid', getid);
    },
    editCategory(cateid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
      axios({
        method: 'post',
        url: '/admin/product/productCategoryEdit',
        data: { cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          self.cate_name = response.data.cateinfo.cate_name;
          self.pid = response.data.cateinfo.pid;
          self.cateid = response.data.cateinfo.id;
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
    delCategory(cateid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/product/productCategoryDel',
        data: { cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
            for (const i in self.categorylist) {
              const delid = self.categorylist[i].id;
              if (delid == cateid) {
                self.categorylist.splice(i, 1);
              }
            }
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
  },
};
